import "./summary-modal.scss";
import FontBody1 from "../../../../../components/fonts/font-body1/font-body1";
import {FONT_COLOR, FONT_VARIANT} from "../../../../../components/fonts/font-props";
import {DefaultModalLayout} from "../../../../../components/modal/layouts/default-modal-layout";
import {IPlan, IPlanEditorModel} from "../../../../../models/Plan";
import PlanCard from "../../../../subscription-plans/components/plan-card/plan-card";
import PlanInfo from "../../../../subscription-plans/components/plan-info/plan-info";
import SubscriptionPlansStore, {PlanStore} from "../../../../subscription-plans/stores/subscription-plans-store";
import FontBody2 from "../../../../../components/fonts/font-body2/font-body2";
import Icon from "../../../../../components/icons/icon/icon";
import IconNext from "../../../../../components/icons/icon-next/icon-next";
import IconChevronDown from "../../../../../components/icons/icon-chevron-down/icon-chevron-down";
import React from "react";
import {PLAN_CHARGE_TYPES} from "../../../stores/subscription-plan-editor-store";

interface SummaryModalProps {
    planEditorModel?: IPlanEditorModel;
    onClose: () => void;
}

const SummaryModal: React.FC<SummaryModalProps> = ({planEditorModel, onClose}) => {
    if (!planEditorModel) {
        return null;
    }

    const planModel: IPlan = {
        features: [],
        period: undefined,
        type: PLAN_CHARGE_TYPES.RECURRING,
        id: planEditorModel.id,
        name: planEditorModel.name ?? '',
        internal_name: planEditorModel.internal_name ?? '',
        price: planEditorModel.price ?? 0,
        rma_quota: planEditorModel.rma_quota ? String(planEditorModel.rma_quota) : '',
        price_per_extra_rma: planEditorModel.price_per_extra_rma ?? planEditorModel.price_per_extra_rma,
        tag: planEditorModel.tag ?? '',
        tag_color: planEditorModel.tag_color ?? '',
        plan_description: planEditorModel.plan_description ?? '',
        is_custom: planEditorModel.is_custom ?? false,
        deprecated: planEditorModel.deprecated ?? false,
        capped_amount: planEditorModel.capped_amount ?? 0,
        user_addons: [],
        price_with_addons: 0,
        plan_features_with_addons: [],
        parent_plan_features: [],
        parent_plan_id: 0,
        updated_at: planEditorModel.updated_at ?? '',
        trial_days: planEditorModel.trial_days ?? 0,
        plan_type: 'regular',
        short_description: planEditorModel.short_description ?? '',
        is_default_coverage_plan: false,
    }

    const plan = new PlanStore(planModel);

    const setShowAddons = () => {
        const showAddons = SubscriptionPlansStore.showMore;
        SubscriptionPlansStore.showMore = !showAddons;
    }

    return <DefaultModalLayout 
        isCloseDisabled={false}
        onCloseClicked={onClose}
        buttons={[
            {
                text: 'Close',
                onClick: onClose
            }
        ]}
        >
        <div className="summary-modal-content">
            <div className="summary-modal-card-wrapper">
                <FontBody1 color={FONT_COLOR.NEUTRAL3}>Summary</FontBody1>
                <PlanCard
                    labeled={!!plan.tag}
                    labelBgColorVariable={plan.tag_color}
                    labelText={plan.tag}
                >
                    <>
                        <PlanInfo
                            plan={plan}
                            planButtonData={{
                                isCurrent: false,
                                caption: 'select',
                                target: '',
                                href: '#',
                            }}
                        />
                        <div className="plan-info-addons-section-expand-button-wrapper" onClick={setShowAddons}>
                            {!SubscriptionPlansStore.showMore &&
                                <>
                                    <div className="plan-info-addons-section-button-text">
                                        <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>More
                                            details</FontBody2>
                                    </div>
                                    <div className="plan-info-addons-section-button-icon">
                                        <Icon Component={IconNext}/>
                                    </div>
                                </>
                            }
                            {SubscriptionPlansStore.showMore &&
                                <>
                                    <div className="plan-info-addons-section-button-text">
                                        <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>Less
                                            details</FontBody2>
                                    </div>
                                    <div className="plan-info-addons-section-button-icon">
                                        <Icon Component={IconChevronDown}/>
                                    </div>
                                </>
                            }
                        </div>
                    </>
                </PlanCard>
            </div>
        </div>
    </DefaultModalLayout>
}

export default SummaryModal;
